import { addListener, createListenerMiddleware } from "@reduxjs/toolkit";

import type { AppDispatch, RootState } from "../@types";
import { addAppMiddleware } from "./middleware.utils";

type ExtraArguments = typeof extra;
const extra = {
  test() {
    console.log("Extra option function called");
    return "Test result from extra option";
  }
};
const listener = createListenerMiddleware({
  extra,
  onError: console.error
});

const startAppListening = listener.startListening.withTypes<RootState, AppDispatch, ExtraArguments>();
const stopAppListening = listener.stopListening.withTypes<RootState, AppDispatch, ExtraArguments>();
const addAppListener = addListener.withTypes<RootState, AppDispatch, ExtraArguments>();
const clearAppListeners = listener.clearListeners;
const listenerMiddleware = listener.middleware;

addAppMiddleware(listenerMiddleware);
export { addAppListener, clearAppListeners, listenerMiddleware, startAppListening, stopAppListening };
